export function loadWalletInfo() {
  return {
    type: 'LOAD_WALLET_INFO',
  };
}

export function loadWalletInfoCompletion(data, error) {
  return {
    type: 'LOAD_WALLET_INFO_COMPLETION',
    data,
    error,
  };
}

export function loadWalletFlowList(range, time) {
  return {
    type: 'LOAD_WALLET_FLOW_LIST',
    range,
    time,
  };
}

export function loadWalletFlowListCompletion(range, data, error) {
  return {
    type: 'LOAD_WALLET_FLOW_LIST_COMPLETION',
    range,
    tool: data && data.tool,
    list: (data && data.listData) || [],
    error,
  };
}

export function resetMoneyExport() {
  return {
    type: 'RESET_MONEY_EXPORT',
  };
}

export function updateMoneyExportInput(input) {
  return {
    type: 'UPDATE_MONEY_EXPORT_INPUT',
    input,
  };
}

export function loadMoneyExportInfo() {
  return {
    type: 'LOAD_MONEY_EXPORT_INFO',
  };
}

export function loadMoneyExportInfoCompletion(data, error) {
  return {
    type: 'LOAD_MONEY_EXPORT_INFO_COMPLETION',
    data,
    error,
  };
}

export function exportMoney(bankCardId, money, payPass) {
  return {
    type: 'EXPORT_MONEY',
    bankCardId,
    money,
    payPass,
  };
}

export function exportMoneyCompletion(data, error) {
  return {
    type: 'EXPORT_MONEY_COMPLETION',
    data,
    error,
  };
}
